import { render, staticRenderFns } from "./FreightBillInfo.vue?vue&type=template&id=4e001d84"
import script from "./FreightBillInfo.vue?vue&type=script&lang=js"
export * from "./FreightBillInfo.vue?vue&type=script&lang=js"
import style0 from "./FreightBillInfo.vue?vue&type=style&index=0&id=4e001d84&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e001d84')) {
      api.createRecord('4e001d84', component.options)
    } else {
      api.reload('4e001d84', component.options)
    }
    module.hot.accept("./FreightBillInfo.vue?vue&type=template&id=4e001d84", function () {
      api.rerender('4e001d84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/FreightBillInfo.vue"
export default component.exports